import './shims.js'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import registerServiceWorker from './registerServiceWorker'
import TranslationProvider from './components/TranslationProvider.js'
import App from './App'
import store from './store.js'
import 'normalize.css'
import 'react-tippy/dist/tippy.css'
import './index.css'

ReactDOM.render(
  <Provider store={store}>
    <TranslationProvider>
      <App />
    </TranslationProvider>
  </Provider>,
  document.getElementById('root')
)
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js